import { api } from 'shared/sdk';

export const typeToApiMapping = {
  resource: api.trackResourceDetailImpression,
  connectVideo: api.trackConnectVideoDetailImpression,
  investor: api.trackInvestorDetailImpression,
  serviceProvider: api.trackServiceProviderDetailImpression,
  vendor: api.trackVendorDetailImpression
};
